import { differenceInYears } from 'date-fns';

function getAge(date) {
  return differenceInYears(new Date(), date);  // returns a number (int)
}

export default getAge;